export function browserUnsupported() {
  return !CSS.supports('container-type', 'inline-size');
}
